import React, { useState } from "react";
import InputMask from 'react-input-mask';
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
} from "@mui/material";
import {
  TextField,
  Container,
  Grid
} from "@mui/material";
import { Btn } from "../../AbstractElements";
import ComponentToView from "./ComponentToView";
import ComponentToPrint from "./ComponentToPrint";
import { errors } from "@telerik/kendo-intl";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment/moment";
import { Gender } from "../../Constant";
import ResetConfirmModal from "./ResetConfirmModal";
import { getUserRole, ShowSucess } from "../../_helper/helper";
import axios from "axios";
import { useAuth } from "oidc-react";

const ResetModel = (props) => {
  const descriptionElementRef = React.useRef(null);
  const existdata = props.data;
  // const [selectedRecordOption, setSelectedRecordOption] = useState("All");
  const [selectedType, setSelectedType] = useState("All");
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const { userData } = useAuth();
  // const [selected]

  // const [formData, setFormData] = useState({
  //   Id: existdata.Id?existdata.Id:null,
  //   FirstName:existdata.FirstName,
  //   LastName:existdata.LastName,
  //   MiddleName:existdata.MiddleName,
  //   DOB:existdata.DOB,
  //   Gender:existdata.Gender,
  //   SSN:existdata.SSN,
  //   Email:existdata.Email,
  //   MailingAddress:existdata.MailingAddress,
  //   City:existdata.City,
  //   State:existdata.State,
  //   Zip:existdata.Zip,
  //   ContactNo:existdata.ContactNo,
  //   HomeAddress:existdata.HomeAddress,
  //   HomeCity:existdata.HomeCity,
  //   HomeState:existdata.HomeState,
  //   HomeZip:existdata.HomeZip,
  //   HomeContactNo:existdata.HomeContactNo,
  // });

  // const handleChange = (e) => {
  //   console.log('date',e);
    
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value?.toUpperCase() }));
  //   props.updateCurrentRecordinBulk({...formData,[name]: value?.toUpperCase()})

  // };
  // const handleChangeDt = (e,name) => {
  //   console.log('datellll',e?.$d , name);
  //   const formatDate = e?.$d;
                                        
  //   let date1 =  moment(formatDate).format("MM/DD/YYYY");
  //   setFormData((prev) => ({ ...prev, [name]: date1 }));
  //   props.updateCurrentRecordinBulk({...formData,[name]: date1})
  // };

   const ResetBlanketData = (Id) => {
      const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
      
      axios
        .post(`${newBaseURL}/BlanketGG1/ResetBlanket?parentid=${Id}&Type=${selectedType}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
            Role: getUserRole(userData),
          },
        })
        .then((response) => {
          // retrievedData = response.data.results;
          // setBatchData(retrievedData[0]);
          console.log("123123 finalResponsexxx", response)
          ShowSucess("Blanket Reset Successfully!")
          setOpenConfirmation(false)
          props?.onClose();

           
        })
        .catch((error) => {
          console.warn("Cannot retrieve user data", error);
        });
  };

  const onConfirm = () => {
    console.log("1231231 confirm clicked")
    ResetBlanketData(props?.ParentId)
  }
  const handleChangeGender = (val) => {
    console.log("1231232 value", val)
    setSelectedType(val);
    // setFormData((prev) => ({ ...prev, [name]: val }));
    // props.updateCurrentRecordinBulk({...formData,[name]: val})
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setOpenConfirmation(true);
    // props.updateCurrentRecordinBulk(formData,true)
    // Send data to server here
  };
  // React.useEffect(() => {
  //   if (props.open) {
  //     const { current: descriptionElement } = descriptionElementRef;
  //     if (descriptionElement !== null) {
  //       descriptionElement.focus();
  //     }
  //   }
  // }, [props.open]);
  return (
    <div>
 
      <Dialog
        maxWidth="md"
        open={props.open}
        onClose={props.onClose}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* <div>{`Reset Blanket - ${props?.batchName}`}</div> */}
            <div>{`Reset Blanket will only operate during UAT(testing)`}</div>
            <div className="d-flex justify-content-end ">
 
              <div
                attrBtn={{
                  className: "m-1",
                  color: "primary",
                  onClick: props.onClose,
                }}
                
                onClick={ props.onClose}
              >
                X
              </div>
            </div>{" "}
          </div>
        </DialogTitle>
        <DialogContent dividers={"paper"} style={{minWidth:'300px'}}>
        <form >
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <FormLabel className="mt-2 mr-2" style={{marginRight:'10px', color:"#000000de"}}  > </FormLabel>                            
            <FormControl component="fieldset">
              <RadioGroup
                value={selectedType}
                // value={formData["Gender"] || ""}
                // value={""}
                onChange={(event)=>{handleChangeGender(event.target.value)}}
                row
              >
                <div>
                <FormControlLabel
                  value="All"
                  control={<Radio />}
                  label="All (Reset the Blanket GG1 to Dept Admin where All NPA, Payroll Staging and Payroll Master records are removed)"
                />
                </div>
                <div>
                <FormControlLabel
                  value="NPA"
                  control={<Radio />}
                  label="NPA (Reset the Blanket GG1 to Submitted for NPA, where Applicant(s) are removed from the Employee Master & their NPA Records)"
                />
                </div>
                <div>
                <FormControlLabel
                  value="Payroll"
                  control={<Radio />}
                  label="Payroll (Reset the Blanket GG1 to Payroll Staging where Applicant(s) are removed from the Payroll Master,  and return all records to the Payroll Staging)"
                />
                </div>
                        
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
        
        <Button
          variant="contained"
          color="primary"
          type="button"
          style={{float: "right",  marginTop: 20 }}
          onClick={handleSubmit}
        >
          Reset Now
        </Button>
      </form>
        </DialogContent>
      </Dialog>
      {openConfirmation && (
        <ResetConfirmModal
          open={openConfirmation}
          setOpen={setOpenConfirmation}
          confimClick={onConfirm}
          cnfrmBtnName="Yes"
          cancelBtnName="No"
          message={"Are you sure to make this change?"}
          // modalHeader="Alert Message"
        />
      )}
    </div>
  );
};
export default ResetModel;
